import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { SizeLadderDraft } from "@/lib/manufacturing/seriesSizeLadder";

export function extractSeriesSizeLadderFromTranscript(transcript: string) {
  return manufacturingFetch<{
    ok: true;
    draft: SizeLadderDraft;
    sizes: string[];
    sizes_raw: string;
    outcome: string;
    source: "llm" | "heuristic";
  }>("/api/mfg/series-wizard/extract-size-ladder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ transcript }),
  });
}
